import * as Sentry from "@sentry/react"

import { AnalyticsEvent } from "@/services/analytics/events"

export const SentryTracking = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  track(name: AnalyticsEvent, data: Record<string, any> = {}) {
    Sentry.captureMessage(name, { level: "info", extra: data })
  },
}
